// frontend/src/services/api/config.js

function getAPIUrl() {
  const hostname = window.location.hostname;

  // 🔧 DESARROLLO LOCAL - Emulador
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:5001/lemmon-app-test-env/us-central1';
  }

  // 🧪 AMBIENTE DE PRUEBAS
  if (hostname === 'lemmon-app-test-env.web.app' ||
      hostname === 'lemmon-app-test-env.firebaseapp.com' ||
      hostname === 'uat.lemmontags.com') {
    return '';  // URLs relativas = mismo dominio = no CORS
  }

  // 🚀 PRODUCCIÓN
  if (hostname === 'lemmontags.com' ||
      hostname === 'www.lemmontags.com') {
    return 'https://lemmontags.com';
  }

  // Default: URL relativa
  return '';
}

/**
 * URL directa de Cloud Functions (para iframes, imágenes, etc.)
 * Necesario porque el hosting no puede servir contenido en iframes
 */
function getFunctionsUrl() {
  const hostname = window.location.hostname;

  // 🔧 DESARROLLO LOCAL - Emulador
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:5001/lemmon-app-test-env/us-central1/adminApp';
  }

  // 🧪 AMBIENTE DE PRUEBAS
  if (hostname === 'lemmon-app-test-env.web.app' ||
      hostname === 'lemmon-app-test-env.firebaseapp.com' ||
      hostname === 'uat.lemmontags.com') {
    return 'https://us-central1-lemmon-app-test-env.cloudfunctions.net/adminApp';
  }

  // 🚀 PRODUCCIÓN
  return 'https://us-central1-identityverifier-1df5b.cloudfunctions.net/adminApp';
}

export const API_URL = getAPIUrl();
export const FUNCTIONS_URL = getFunctionsUrl();